module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO06MetasEnElTiempo.28dc957.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO06MetasEnElTiempo.mp4
// module id = 734
// module chunks = 1